<template>
    <b-card>
        <b-row>
            <b-col md="7" class="p-0">
                <div class="my-2 mb-4 ml-4 mr-4">
                    <h2>Create Office</h2>
                    <v-stepper alt-labels v-model="e1">
                        <v-stepper-header>
                            <template v-for="(list, index) in getSteppersList">
                                <v-stepper-step
                                    :step="index + 1"
                                    :key="index + list"
                                    class="v-stepper-step-outline"
                                    >{{ list }}</v-stepper-step
                                >
                                <v-divider
                                    v-if="index !== getSteppersList.length - 1"
                                    :key1="index + list"
                                />
                            </template>
                        </v-stepper-header>

                        <v-stepper-items>
                            <v-stepper-content :step="getSteps('office')">
                                <s-office
                                    @place_changed="setPlace"
                                    :isBillTo="false"
                                    :tenants="tenants"
                                    ref="office"
                                >
                                    <template v-slot:footer-button="data">
                                        <div
                                            class="d-flex justify-content-center align-items-center"
                                        >
                                            <b-button
                                                style="max-width: 80px"
                                                class="btn btn-block"
                                                btn-color="primary"
                                                @isValid="
                                                    (val) => (officeValid = val)
                                                "
                                                @click="OfficeToNext(data.data)"
                                                >Next</b-button
                                            >
                                        </div>
                                    </template>
                                </s-office>
                            </v-stepper-content>

                            <v-stepper-content :step="getSteps('organization')">
                                <s-organization
                                    @place_changed="setPlace"
                                    :officeData="office"
                                    :isLightMode="isLightConfiguration"
                                    ref="organization"
                                >
                                    <template
                                        v-slot:footer-button="data"
                                        class="btn btn-block3"
                                    >
                                        <div
                                            class="d-flex justify-content-center align-items-center mt-4"
                                        >
                                            <v-btn
                                                flat
                                                @click="e1 = 1"
                                                btn-back="primary"
                                                class="mr-2"
                                                style="max-width: 80px"
                                            >
                                                <span
                                                    class="fa fa-reply"
                                                ></span>
                                            </v-btn>

                                            <b-button
                                                class="btn btn-block ml-2"
                                                btn-color="primary"
                                                style="max-width: 80px"
                                                @isValid="
                                                    (val) =>
                                                        (organizationValid =
                                                            val)
                                                "
                                                @click="OrgToNext(data.data)"
                                                >Next</b-button
                                            >
                                        </div>
                                    </template>
                                </s-organization>
                            </v-stepper-content>

                            <v-stepper-content
                                :step="getSteps('billTo')"
                                v-if="!isLightConfiguration"
                            >
                                <s-office
                                    :isBillTo="true"
                                    :officeData="office"
                                    :setValues="useOfficeDataInBillTo"
                                >
                                    <template v-slot:name="billname">
                                        <b-row class="mt-1 mx-1">
                                            <b-form-checkbox
                                                type="checkbox"
                                                v-model="useOfficeDataInBillTo"
                                            >
                                                Use same address as office
                                            </b-form-checkbox>
                                        </b-row>
                                        <c-input
                                            v-if="!useOfficeDataInBillTo"
                                            inputType="text"
                                            inputId="name"
                                            lableText="Bill Name"
                                            v-model="billname.data"
                                            class="mt-3"
                                        />
                                    </template>
                                    <template v-slot:footer-button="data">
                                        <div
                                            class="d-flex justify-content-center align-items-center mt-4"
                                        >
                                            <v-btn
                                                flat
                                                @click="e1 = 2"
                                                btn-back="primary"
                                                style="max-width: 80px"
                                                class="btn btn-block mr-2"
                                            >
                                                <span
                                                    class="fa fa-reply"
                                                ></span>
                                            </v-btn>

                                            <b-button
                                                class="btn btn-block ml-2"
                                                style="max-width: 100px"
                                                btn-color="primary"
                                                disable=""
                                                @click="BillToNext(data.data)"
                                                >Next</b-button
                                            >
                                        </div>
                                    </template>
                                </s-office>
                            </v-stepper-content>

                            <v-stepper-content
                                :step="getSteps('authentication')"
                            >
                                <s-authentication
                                    :officeData="office"
                                    :isLightMode="isLightConfiguration"
                                >
                                    <template v-slot:footer-button="data">
                                        <div
                                            class="d-flex justify-content-center align-items-center mt-4"
                                        >
                                            <v-btn
                                                v-if="!isLightConfiguration"
                                                flat
                                                @click="e1 = 3"
                                                btn-back="primary"
                                            >
                                                <span
                                                    class="fa fa-reply"
                                                ></span>
                                            </v-btn>
                                            <v-btn
                                                v-else
                                                flat
                                                @click="e1 = 2"
                                                style="max-width: 80px"
                                                btn-back="primary"
                                                class="mr-2"
                                            >
                                                <span
                                                    class="fa fa-reply"
                                                ></span>
                                            </v-btn>

                                            <b-button
                                                class="btn btn-block ml-2"
                                                style="max-width: 100px"
                                                btn-color="primary"
                                                @click="AuthToNext(data.data)"
                                                >Next</b-button
                                            >
                                        </div>
                                    </template>
                                </s-authentication>
                            </v-stepper-content>

                            <v-stepper-content :step="getSteps('agreement')">
                                <s-agreement
                                    ref="agreement"
                                    :catalogDomainData="catalogDomainData"
                                    :showPaymentPicker="
                                        (office &&
                                            office.category &&
                                            office.category.value ===
                                                'DISTRIBUTOR') ||
                                        (office &&
                                            office.category &&
                                            office.category.value === 'DEALER')
                                    "
                                    :showsellerPaymentPicker="
                                        office &&
                                        office.category &&
                                        office.category.value === 'SELLER'
                                    "
                                >
                                    <template v-slot:footer-button="data">
                                        <br />
                                        <div
                                            class="d-flex justify-content-center align-items-center mt-4"
                                        >
                                            <v-btn
                                                v-if="!isLightConfiguration"
                                                flat
                                                @click="e1 = 4"
                                                btn-back="primary"
                                            >
                                                <span
                                                    class="fa fa-reply"
                                                ></span>
                                            </v-btn>
                                            <v-btn
                                                v-else
                                                flat
                                                @click="e1 = 3"
                                                btn-back="primary"
                                                style="max-width: 80px"
                                                class="mr-2"
                                            >
                                                <span
                                                    class="fa fa-reply"
                                                ></span>
                                            </v-btn>

                                            <b-button
                                                class="btn btn-block ml-2"
                                                style="max-width: 100px"
                                                btn-color="primary"
                                                @click="AgreeToNext(data.data)"
                                                >Next</b-button
                                            >
                                        </div>
                                    </template>
                                </s-agreement>
                            </v-stepper-content>

                            <v-stepper-content :step="getSteps('done')">
                                <s-thanks @done="done"></s-thanks>
                            </v-stepper-content>
                        </v-stepper-items>
                    </v-stepper>
                </div>
            </b-col>
            <b-col md="5" class="p-0">
                <img
                    src="img/svg/createOffice.svg"
                    class="img-avatar"
                    v-if="e1 != 2 && e1 != 1 && e1 != 3"
                />
                <div v-else class="map-container">
                    <GmapMap
                        :center="position"
                        :zoom="12"
                        map-type-id="terrain"
                        class="map"
                    >
                        <GmapMarker
                            label="★"
                            :draggable="false"
                            :position="position"
                        />
                    </GmapMap>
                </div>
            </b-col>
        </b-row>
    </b-card>
</template>

<script>
import cInput from "@/components/Common/CustomInput";
import sOffice from "@/components/Office/OfficeStepper.vue";
import sOrganization from "@/components/Partner/OrganizationStepper.vue";
import sAuthentication from "@/components/Partner/AuthenticationStepper.vue";
import sThanks from "@/components/Office/ThankYouStepper.vue";
import sAgreement from "@/components/Partner/Agreement.vue";
import { mapGetters, mapActions } from "vuex";
import { getReverseGeoCode } from "@/services/geocode";
import { invalid } from "moment";
import { listOrderForAllUsers } from "@/services/order";

export default {
    name: "CreateOffice",
    components: {
        sOffice,
        sOrganization,
        sAuthentication,
        sThanks,
        sAgreement,
        cInput,
    },
    data() {
        return {
            formFillupCheckerKey: true,
            isLightConfiguration: true,
            useOfficeDataInBillTo: true,
            currentUser: "",
            loading: false,
            e1: 0,
            tenants: [],
            office: null,
            officevalid: false,
            organizationValid: false,
            catalogDomainData: [],
            organization: null,
            billTo: null,
            authentication: null,
            agreement: null,
            markers: [],
            place: null,
            position: {
                lat: 0,
                lng: 0,
            },
        };
    },
    mounted() {
        this.isLightConfiguration =
            this.tenantPreferences.lightMode == undefined
                ? true
                : this.tenantPreferences.lightMode;
        this.catalogDomainData = this.$currentUserData.catalogInfo;
    },
    computed: {
        getSteppersList() {
            const data = [];
            data.push("Office");
            data.push("Organization");
            if (!this.isLightConfiguration) {
                data.push("Bill_To");
            }
            data.push("Authentication");
            data.push("Agreement");
            data.push("Done");
            return data;
        },
        userRole() {
            if (this.$store.getters["auth/getUserRole"]) {
                return this.$store.getters["auth/getUserRole"];
            } else {
                return JSON.parse(sessionStorage.getItem("userLogin"))["role"];
            }
        },
        ...mapGetters({
            getCategoryList: "catalog/GetCategoryList",
            tenantPreferences: "tenant/GetTenantPreferences",
        }),
    },
    methods: {
        async OfficeToNext(item) {
            const isValid = await this.$refs.office.isValid();

            if (!isValid) return;

            this.office = item;
            this.e1 = 2;
        },
        async OrgToNext(item) {
            const isValid = await this.$refs.organization.isValid();

            if (!isValid) return;

            this.organization = item;
            this.e1 = 3;
        },
        async BillToNext(item) {
            this.billTo = item;
            try {
                const data = await getReverseGeoCode(
                    `${this.billTo.address.street1},${this.billTo.address.city},${this.billTo.address.state},${this.billTo.address.country}`,
                );
                if (data.data.status === "OK") {
                    this.billTo.address.location.coordinates = [
                        data.data.results[0].geometry.location.lng,
                        data.data.results[0].geometry.location.lat,
                    ];
                }
                this.e1 = 4;
            } catch (error) {}
        },
        async AuthToNext(item) {
            if (!item.passwordValid) {
                this.$swal({
                    title: "Password Validation failed.",
                    text: "Enter a strong password !!!",
                    type: "warning",
                });
                return;
            }
            delete item.passwordValid;
            let isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(item.email);

            if (
                item.email != "" &&
                item.phone != "" &&
                item.userName != "" &&
                item.password != "" &&
                item.securityQuestions &&
                item.securityQuestions.answer &&
                item.securityQuestions.question.value &&
                isValidEmail
            ) {
                this.authentication = item;
                this.e1 += 1;
            } else {
                this.$swal({
                    title: "Error",
                    text: "Please fillup required fields.",
                    type: "error",
                });
            }
        },
        async AgreeToNext(item) {
            const isValid = await this.$refs.agreement.isValid();

            if (!isValid) return;
            const userLoginData = this.$currentUserData;
            this.agreement = item;
            const { organization, billTo, office, authentication, agreement } =
                this;
            const authenticationCopy = { ...authentication };
            authenticationCopy.securityQuestions = {
                question: authentication.securityQuestions.question.value,
                answer: authentication.securityQuestions.answer,
            };

            let tenant = this.$store.getters["auth/getUserID"];
            if (this.$userRole !== "Tenant") {
                tenant = userLoginData.tenant;
            }
            office.officeType = office.officeType.value;
            delete authenticationCopy.securityQA;
            let authorization = {};
            let orgaccess = [];
            if (
                organization.orgAccessList !== null &&
                organization.orgAccessList.length > 0
            ) {
                organization.orgAccessList.map((obj) => {
                    orgaccess.push(obj._id);
                });
            }
            authorization.orgAccess = {
                orgAccessLevel: "Global",
                orgAccessList: orgaccess,
            };

            delete organization.orgAccessLevel;
            delete organization.orgAccessList;

            let agreementData = [];
            try {
                if (
                    Array.isArray(agreement.catalogCategory) &&
                    agreement.catalogCategory.length > 0
                ) {
                    if (agreement.fetchCatagoryKey) {
                        agreement.catalogCategory.map((obj) => {
                            agreementData.push({
                                categoryType: "CATEGORY",
                                catalogId: obj._id,
                            });
                        });
                    } else {
                        agreement.catalog.map((obj) => {
                            agreementData.push({
                                categoryType: agreement.market.value,
                                catalogId: obj._id,
                            });
                        });
                    }
                } else {
                    agreement.catalog.map((obj) => {
                        agreementData.push({
                            categoryType: agreement.market.value,
                            catalogId: obj._id,
                        });
                    });
                }
                this.formFillupCheckerKey = true;
            } catch (err) {
                this.formFillupCheckerKey = false;
                this.$swal({
                    title: "Error",
                    text: "Please select market and catalog properly",
                    type: "error",
                });
            }
            let agreementPayload = {
                doc: agreement.doc,
                valid: agreement.valid,
                marketSegment: agreementData,
            };

            const payload = {
                authentication: authenticationCopy,
                billTo,
                office,
                organization,
                tenant,
                agreement: agreementPayload,
                category: "OFFICE",
                officeHierarchy: userLoginData._id,
            };
            this.loading = true;
            await this.$store
                .dispatch("partner/createPartner", payload)
                .then((result) => {
                    this.loading = false;
                    this.$swal({
                        title: "Success",
                        text: "Office Created Successfully!",
                        type: "success",
                    });
                })
                .catch((error) => {
                    this.loading = false;
                    this.e1 = 1;
                    this.$swal({
                        title: "Error",
                        text: "Could not create office",
                        type: "error",
                    });
                });
            if (this.isLightConfiguration) {
                this.e1 = 5;
            } else {
                this.e1 = 6;
            }
        },
        done() {
            this.$router.push({ path: "/office-management" });
        },
        async setPlace(p) {
            let place = await p;
            let position = {
                lat: place.geometry.location.lat(),
                lng: place.geometry.location.lng(),
            };
            this.position = position;
        },
        getSteps(key) {
            if (!this.isLightConfiguration) {
                switch (key) {
                    case "office":
                        return 1;
                    case "organization":
                        return 2;
                    case "billTo":
                        return 3;
                    case "authentication":
                        return 4;
                    case "agreement":
                        return 5;
                    case "done":
                        return 6;
                }
            } else {
                switch (key) {
                    case "office":
                        return 1;
                    case "organization":
                        return 2;
                    case "authentication":
                        return 3;
                    case "agreement":
                        return 4;
                    case "done":
                        return 5;
                }
            }
        },
    },
};
</script>

<style scoped>
.card {
    border-width: inherit;
    border-radius: 2px;
    box-shadow: 0 0 35px 0 rgba(154, 161, 171, 0.15) !important;
}
[col-4="image"] {
    background-color: aliceblue !important;
}
[btn-back="primary"] {
    background-color: var(--primary) !important;
    margin: 0px;
    height: 41px;
    color: white;
    border-radius: 0px;
}
.btn-secondary {
    background-color: var(--secondary);
    border-color: var(--secondary);
    height: 41px;
    min-width: 90px; 
    font-weight: 600;
    font-size: medium;
    letter-spacing: 2px;
    font-family: "Lato";
    color: white;
    border: 0px;
    border-radius: 0px;
}
.img-avatar {
    width: 100%;
    margin: 150px 0 0 0 !important;
}
</style>
<style>
.v-stepper {
    box-shadow: none;
    /* padding: 19px; */
}

.v-stepper__header {
    box-shadow: none;
}

.v-btn:before {
    opacity: -0.12 !important;
}

.v-stepper--alt-labels .v-stepper__step {
    flex-basis: 0px;
}

.v-stepper-step-outline {
    border: 1px solid var(--primary) !important;
    height: 0px;
    border-radius: 50%;
    width: 0px;
    margin-top: 8px;
    /* margin-right: 0px; */
    /* margin-left: 0; */
    margin-bottom: 40px;
    float: left;
}
@-moz-document url-prefix() {
    .v-stepper-step-outline {
        padding: 24px 4px 24px 4px;
    }
}

/* Active Tab Class*/
.theme--light.v-stepper .v-stepper__step__step,
.theme--light.v-stepper .v-stepper__step__step .v-icon {
    color: #ffffff;
    background-color: var(--primary) !important;
}

.v-stepper--alt-labels .v-stepper__step__step {
    margin-right: 0;
    margin-bottom: 22px;
    margin-top: -21px;
}
.v-stepper__step__step {
    min-height: 42px;
    min-width: 42px !important;
}
.v-stepper__content {
    padding: 0px !important;
    margin-top: 25px;
}
/* Deactive Stepper */
.theme--light.v-stepper
    .v-stepper__step:not(.v-stepper__step--active):not(
        .v-stepper__step--complete
    ):not(.v-stepper__step--error)
    .v-stepper__step__step {
    background: var(--secondary) !important;
}
/* divider between stepper */
.v-stepper--alt-labels .v-stepper__header .v-divider {
    margin: 35px 0px;
    -ms-flex-item-align: start;
    align-self: flex-start;
}
.map-container {
    /* height: 800px; */
    display: flex-start;
    align-items: center;
    justify-content: center;
    margin-top: 170px !important;
}

.map {
    width: 100%;
    height: 350px;
    min-height: 300px;
    /* margin-bottom: 62px; */
}

@media screen and (max-width: 768px) {
    .map-container {
        height: 300px;
    }

    .map {
        min-height: 200px;
    }
}
</style>
